// Placeholder "no allergy" values returned by the API that shouldn't appear in
// allergy lists (e.g. "NA", "NA Na", "N/A", "None", "No known allergies").
// Compared after stripping to letters only, so it only matches when the WHOLE
// value is a placeholder — a real entry like "NA, Peanuts" still shows.
export const NO_ALLERGY_VALUES = new Set([
  "na", "nana", "nan", "none", "nil", "no", "nka",
  "noallergies", "noknownallergies", "nonknown",
]);

export function hasRealAllergy(value) {
  const normalised = String(value || "").toLowerCase().replace(/[^a-z]/g, "");
  return normalised !== "" && !NO_ALLERGY_VALUES.has(normalised);
}
